import React from "react";
import { useNavigate } from "react-router-dom";

import "./InventoryWidget.scss";

export const InventoryWidget: React.FC = () => {
  const navigate = useNavigate();

  const handleDumpstersClick = () => navigate("/dumpsters");
  const handleVehiclesClick = () => navigate("/vehicles");

  return (
    <div className="inventory-widget-component">
      <div className="title">Inventory</div>

      <div className="inventory-links-container">
        <div className="column">
          <div className="link" onClick={handleDumpstersClick}>
            Dumpsters
          </div>

          <div className="link" onClick={handleVehiclesClick}>
            Vehicles
          </div>
        </div>
      </div>
    </div>
  );
};
